import {Channel} from './channel.model';
import {ProgramPoster} from './program-controller/program-poster.model';

export class ProgramP {
  constructor(
    public epgProgramId?: string,
    public title?: string,
    public releaseDate?: string,
    public seasonNumber?: string,
    public episodeNumber?: string,
    public startTime?: number,
    public endTime?: number,
    public category?: string,
    public credits?: string,
    public description?: string,
    public posters?: ProgramPoster[],
    public day?: string,
    public endHour?: string,
    public startHour?: string,
    public channel?: Channel,
    public dvidedProgramEpgProgramId?: string,
  ) {}
}

// ProgramP {
//   broadcastType (string, optional),
//   category (string, optional),
//   channel (ChannelP, optional),
//   country (string, optional),
//   credits (ProgramCreditsP, optional),
//   description (string, optional),
//   duration (integer, optional),
//   endTime (integer, optional),
//   epgProgramId (string, optional),
//   episodeNumber (string, optional),
//   mwProgramId (string, optional),
//   npvrEnable (boolean, optional),
//   originalTitle (string, optional),
//   posterLandscapeUrl (string, optional),
//   posterUrl (string, optional),
//   ppvEnable (boolean, optional),
//   programGroup (ProgramGroup, optional),
//   rating (Rating, optional),
//   releaseDate (string, optional),
//   seasonNumber (string, optional),
//   seriesId (string, optional),
//   seriesName (string, optional),
//   startTime (integer, optional),
//   status (string, optional) = ['Inserted', 'Updated', 'Deleted', 'None'],
//   title (string, optional),
//   tstvEnable (boolean, optional),
//   year (string, optional)
//   }
